export class LabelOptions { 
    RequestDHLCustomsInvoice:any;
} 